import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useContext, useEffect, useMemo } from "react";
import { useController } from "react-hook-form";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useFormContext } from "../CustomForm";
import { useAI } from "../../useAI";
import { SnackbarContext } from "components/context/SnackbarProvider";

const CustomMultilineTextField = ({ field, control }) => {
  const { field: fieldProps, fieldState } = useController({
    control,
    name: field.name,
  });
  const { fields, watch } = useFormContext();
  const { displayError } = useContext(SnackbarContext);
  const { askOpenAI, loading, error } = useAI();

  const translationContext = useMemo(() => {
    const field_names = new Set(fields.map((f) => f.name));
    let source = null;
    if (field.name.endsWith("_fr")) {
      const fieldWithoutFr = field.name.replace(/_fr$/, ""); // Retirer "_fr" du nom du champ
      if (field_names.has(fieldWithoutFr)) {
        source = fieldWithoutFr;
      }
      if (field_names.has(fieldWithoutFr + "_en")) {
        source = fieldWithoutFr + "_en";
      }
    } else if (field.name.endsWith("_en")) {
      const fieldWithFR = field.name.replace(/_en$/, "_fr"); // Retirer "_en" du nom du champ
      if (field_names.has(fieldWithFR)) {
        source = fieldWithFR;
      }
    }
    return {
      isTranslatable: !!source,
      source,
    };
  }, [field.name, watch]);

  const callOpenAI = () => {
    const input = watch(translationContext.source);
    if (input) {
      askOpenAI({
        prompt_key: "traduction_en_fr",
        context: {
          text: input,
          title: translationContext.source,
        },
      }).then((data) => {
        if (data && data.response) {
          fieldProps.onChange(data.response);
        }
      });
    }
  };

  useEffect(() => {
    error && displayError(error);
  }, [error]);

  const endAdornment = translationContext.isTranslatable ? (
    <InputAdornment position="end">
      <IconButton onClick={callOpenAI} edge="end">
        <AutoAwesomeIcon />
      </IconButton>
    </InputAdornment>
  ) : null;

  return (
    <TextField
      name={field.name}
      label={field.label}
      variant="outlined"
      fullWidth
      type={"text"}
      helperText={fieldState.error?.message || field.help_text || ""}
      disabled={field.disabled}
      sx={{ display: field.hidden ? "none" : "block" }}
      error={!!fieldState.error}
      multiline
      slotProps={{
        input: {
          endAdornment: endAdornment,
        },
      }}
      {...fieldProps}
    />
  );
};

export default CustomMultilineTextField;
